// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"ShyftPassBookClassRegisterPage_registerForm__B69mA","button":"ShyftPassBookClassRegisterPage_button___UGYc"};